<template>
  <div>
    <div class="flex flex-center q-pa-md row">
      <q-form
        ref="validateForm"
        @submit="onSubmit"
        class="col-10"
        greedy
      >
        <div
          v-if="!isEditing"
          class="text-center text-h5 q-pa-md"
        >
          Review Submission
        </div>
        <div
          v-else
          class="text-center text-h5 q-pa-md"
        >
          Edit Application
        </div>
        <!-- <div class="row items-start">
          <div
            v-show="isEditing"
            class="text-caption q-my-xs text-left col-12"
          >
            <b>NOTE:</b> Changes made here will not reflect in your Colleague account.
            To make changes, please visit Colleague Self-Service.
          </div>
        </div> -->
        <div>
          <div v-if="hasRoles('R&D', 'HRL', 'OTHER-STAFF') && !isApply">
            <div class="text-left text-h5">
              Admin Information
            </div>
            <q-separator />
            <div class="row items-start">
              <q-input label="Session Name:"
                       class="col-6"
                       borderless
                       readonly />
              <q-input v-model="applicationDetails.sessionName"
                       class="col-6"
                       borderless
                       readonly />
            </div>
            <div class="row items-start">
              <q-input label="Application Status:"
                       class="col-6"
                       borderless
                       readonly />
              <q-select v-model="applicationDetails.status"
                        borderless
                        :options="applicationDetails.applicationStatuses"
                        :readonly="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :hide-dropdown-icon="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :rules="[checkSelect]"
                        lazy-rules />
            </div>
            <div class="row items-center">
              <q-input label="Request Status:"
                       class="col-6"
                       borderless
                       readonly />
              <q-input class="col-4"
                       :label="formatApplicationManagementRequestStatus(
                         applicationDetails.latestApplicationManagementRequestType,
                         true)"
                       borderless
                       readonly
                       label-color="black" />
              <q-btn v-if="applicationDetails.latestApplicationManagementRequestType !== 'None'
                       && isEditing"
                     class="text-primary"
                     flat
                     label="Clear"
                     @click="applicationDetails.latestApplicationManagementRequestType = 'None'" />
            </div>
            <div class="row items-start">
              <q-input label="Waitlist Status:"
                       class="col-6"
                       borderless
                       readonly />
              <q-select v-model="applicationDetails.waitlistStatus"
                        borderless
                        :options="applicationDetails.waitlistStatuses"
                        :readonly="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :hide-dropdown-icon="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :rules="[checkSelect]"
                        lazy-rules />
            </div>
            <div class="row items-start">
              <q-input label="Waitlist Reason:"
                       class="col-6"
                       borderless
                       readonly />
            </div>
            <q-input class="q-ma-md"
                     v-model="applicationDetails.waitlistReason"
                     filled
                     borderless
                     :readonly="hasRoles('R&D', 'HRL') ? false : ''"
                     type="textarea" />
            <div class="row items-start">
              <q-input label="Residency Status:"
                       class="col-6"
                       borderless
                       readonly />
              <q-select v-model="applicationDetails.residencyStatus"
                        borderless
                        map-options
                        emit-value
                        :options="applicationDetails.residencyStatuses"
                        :readonly="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :hide-dropdown-icon="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :rules="[checkSelect]"
                        lazy-rules />
            </div>
            <div class="row items-start">
              <q-input label="Move in Group:"
                       class="col-6"
                       borderless
                       readonly />
              <q-select v-model="applicationDetails.moveInGroup"
                        borderless
                        map-options
                        emit-value
                        :options="applicationDetails.moveInGroups"
                        :readonly="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :hide-dropdown-icon="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :rules="[checkSelect]"
                        lazy-rules />
            </div>
            <div class="row items-start">
              <q-input label="DSS Status:"
                       class="col-6"
                       borderless
                       readonly />
              <q-select v-model="applicationDetails.dssAccessible"
                        fill-input
                        borderless
                        :options="['Waived', 'Requested', 'Received', 'Approved']"
                        :readonly="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :hide-dropdown-icon="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :rules="[checkSelect]"
                        lazy-rules />
            </div>
            <div class="row items-start">
              <q-input label="Deposit:"
                       class="col-6"
                       borderless
                       readonly />
              <q-select v-model="applicationDetails.deposit"
                        fill-input
                        borderless
                        :options="['Pending', 'Received', 'Returned']"
                        :readonly="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :hide-dropdown-icon="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''" />
            </div>
            <div class="row items-start">
              <q-input label="SEA Status:"
                       class="col-6"
                       borderless
                       readonly />
              <q-select v-model="applicationDetails.seaStatus"
                        fill-input
                        borderless
                        :options="seaStatusOptions"
                        option-value="value"
                        option-label="label"
                        emit-value
                        map-options
                        :readonly="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :hide-dropdown-icon="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''" />
            </div>
            <div class="row items-start">
              <q-input label="Vaccine Status:"
                       class="col-6"
                       borderless
                       readonly />
              <q-input :label="applicationDetails.vaccinationStatus"
                       borderless
                       readonly
                       label-color="black" />
            </div>
            <div class="row items-start">
              <q-input label="Housing Agreement Status:"
                       class="col-6"
                       borderless
                       readonly />
              <q-checkbox v-if="hasRoles('R&D', 'HRL') && !isReadOnly"
                          v-model="applicationDetails.agreement"
                          label="Agreement Completed"
                          class="q-my-xs"
                          color="green" />
              <q-input v-else
                       :label="$filters.receivedPending(applicationDetails.agreement)"
                       borderless
                       readonly
                       label-color="black" />
            </div>
            <div class="row items-start">
              <q-input label="Student Handbook Agreement Status:"
                       class="col-6"
                       borderless
                       readonly />
              <q-checkbox v-if="hasRoles('R&D', 'HRL') && !isReadOnly"
                          v-model="applicationDetails.handbookAgreement"
                          label="Agreement Completed"
                          class="q-my-xs"
                          color="green" />
              <q-input v-else
                       :label="$filters.receivedPending(applicationDetails.handbookAgreement)"
                       borderless
                       readonly
                       label-color="black" />
            </div>
            <!-- <div class="row items-start">
    <q-input
      label="Share Email with Roommates:"
      class="col-6"
      borderless
      readonly
    />
    <q-checkbox
      v-if="hasRoles('R&D', 'HRL')  && !isReadOnly"
      v-model="applicationDetails.shareEmail"
      label="Share Email with Roommates"
      class="q-my-xs"
      color="green"
    />
    <q-input
      v-else
      :label="$filters.yesNo(applicationDetails.shareEmail)"
      borderless
      readonly
      label-color="black"
    />
  </div> -->
            <div class="row items-start">
              <q-input label="Application Created Date:"
                       class="col-6"
                       borderless
                       readonly />
              <q-input v-if="hasRoles('R&D', 'HRL', 'OTHER-STAFF')"
                       :label="isDefaultDateTime(applicationDetails.applicationCreated)
                ? '' : applicationDetails.applicationCreated"
                       borderless
                       readonly
                       label-color="black" />
            </div>
            <div class="row items-start">
              <q-input label="Application Accepted Date:"
                       class="col-6"
                       borderless
                       readonly />
              <q-input v-if="hasRoles('R&D', 'HRL', 'OTHER-STAFF')"
                       :label="isDefaultDateTime(applicationDetails.applicationAccepted)
                ? '' : applicationDetails.applicationAccepted"
                       borderless
                       readonly
                       label-color="black" />
            </div>
            <div class="row items-start">
              <q-input label="Applied to EAP:"
                       class="col-6"
                       borderless
                       readonly />
              <q-input :label="$filters.yesNo(applicationDetails.hasAppliedToEap)"
                       label-color="black"
                       borderless
                       readonly />
            </div>
            <div class="row items-start">
              <q-input label="Returning For Next Session:"
                       class="col-6"
                       borderless
                       readonly />
              <q-select v-model="applicationDetails.returningForNextSession"
                        fill-input
                        borderless
                        :options="['Yes', 'No', 'Undecided']"
                        :readonly="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
                        :hide-dropdown-icon="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''" />
            </div>
          </div>

          <div class="text-left text-h5">
            Student Information
          </div>
          <q-separator />
          <div class="row items-start">
            <q-input
              label="First Name:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.firstName"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkInput]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Last Name:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.lastName"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkInput]"
              lazy-rules
            />
          </div>
          <div
            v-if="hasRoles('OTHER-STAFF', 'HRL')"
            class="row items-start"
          >
            <q-input
              label="Colleague ID:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.colleagueId"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Chosen Name:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.preferredFirstName"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Mobile Phone:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.mobilePhone"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkIsValidPhone]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Permanent Phone:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.permanentPhone"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkIsValidPhoneOrEmpty]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="DigiPen Email:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.digipenEmail"
              class="col-6"
              type="email"
              :borderless="hasRoles('R&D', 'HRL') && isEditing ? false : ''"
              :readonly="hasRoles('R&D', 'HRL') && isEditing ? false : ''"
              :rules="[checkIsValidEmail]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Permanent Email:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.permanentEmail"
              class="col-6"
              type="email"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkIsValidEmail]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Date of Birth:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-if="!isEditing"
              v-model="applicationDetails.dateOfBirth"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-else
              class="col-6"
              v-model="applicationDetails.dateOfBirth"
              :rules="[ val => !!val || 'Please enter or select date of birth', checkIsValidDate]"
              lazy-rules
              mask="##/##/####"
            >
              <template v-slot:append>
                <q-icon
                  name="event"
                  class="cursor-pointer"
                >
                  <q-popup-proxy
                    ref="qDateProxy"
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      v-model="applicationDetails.dateOfBirth"
                      mask="MM/DD/YYYY"
                      :rules="[ val => !!val || 'Please enter date of birth', checkIsValidDate]"
                      lazy-rules
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div
            v-if="(applicationDetails.genderIdentity?.toLowerCase()?.trim() !== 'other'
              || isEditing)"
            class="row items-start">
            <q-input
              label="Gender Identity:"
              class="col-6"
              borderless
              readonly
            />
            <q-select
              v-model="applicationDetails.genderIdentity"
              class="col-6"
              :options="genderList"
              :readonly="!isEditing"
              :borderless="!isEditing"
              :hide-dropdown-icon="!isEditing"
              :rules="[checkSelect]"
              lazy-rules
            />
          </div>

          <div
            v-if="applicationDetails.genderIdentity?.toLowerCase()?.trim() === 'other'"
            class="row items-start"
          >
            <q-input
              label="Gender Identity (Input):"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.genderIdentityOther"
              class="col-6"
              :readonly="!isEditing"
              :borderless="!isEditing"
              :rules="[ val => !!val || 'Please input gender identity']"
              lazy-rules
            />
          </div>

          <div class="row items-start">
            <q-input
              label="Academic Year:"
              class="col-6"
              borderless
              readonly
            />
            <q-select
              v-model="applicationDetails.academicYear"
              class="col-6"
              :options="academicYearList"
              :readonly="!isEditing"
              :borderless="!isEditing"
              :hide-dropdown-icon="!isEditing"
              :rules="[checkSelect]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Graduating This Year:"
              class="col-6"
              borderless
              readonly
            />
            <q-select
              v-model="applicationDetails.graduatingThisYear"
              class="col-6"
              :options="['Fall','Spring','Summer', 'No']"
              :readonly="!isEditing"
              :borderless="!isEditing"
              :hide-dropdown-icon="!isEditing"
            />
          </div>
        </div>

        <br />
        <div>
          <div class="text-left text-h5">
            Address Information
          </div>
          <q-separator />
          <div class="row items-start">
            <q-input
              label="Permanent Address Line 1:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.permanentAddress"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkInput]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Permanent Address Line 2:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.permanentAddress2"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
            />
          </div>
          <div class="row items-start">
            <q-input
              label="City:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.city"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkInput]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Postal/Zip Code:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.zip"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkInput]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="State/Province:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.state"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkInput]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Country/Region:"
              class="col-6"
              borderless
              readonly
            />
            <q-select
              v-model="applicationDetails.country"
              class="col-6"
              :readonly="!isEditing"
              :borderless="!isEditing"
              :hide-dropdown-icon="!isEditing"
              :rules="[checkSelect]"
              lazy-rules
              use-input
              hide-selected
              fill-input
              input-debounce="0"
              :options="countriesOptions"
              @filter="countriesFilter"
            />
          </div>
        </div>

        <br />
        <div>
          <div class="text-left text-h5">
            Emergency Contact Information
          </div>
          <q-separator />
          <div class="row items-start">
            <q-input
              label="Emergency Contact Name:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.emergencyContactName"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkInput]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Emergency Contact Relation:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.emergencyContactRelation"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Emergency Contact Phone:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.emergencyContactPhone"
              class="col-6"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkIsValidPhone]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Emergency Contact Email:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.emergencyContactEmail"
              class="col-6"
              type="email"
              :borderless="isEditing ? false : ''"
              :readonly="isEditing ? false : ''"
              :rules="[checkIsValidEmail]"
              lazy-rules
            />
          </div>
        </div>

        <br />
        <div>
          <div class="text-left text-h5">
            Housing Preferences
          </div>
          <q-separator />
          <div>
            <div class="row items-start">
              <q-input
                label="Roommates Have Same Gender Identity:"
                class="col-6"
                borderless
                readonly
              />
              <q-select
                v-model="applicationDetails.liveWithSameGenders"
                class="col-6"
                :readonly="!isEditing"
                :borderless="!isEditing"
                :hide-dropdown-icon="!isEditing"
                :options="['Same', 'Any', 'Other']"
                :rules="[checkSelect]"
                lazy-rules
              />
            </div>
            <div
              v-if="applicationDetails.liveWithSameGenders === 'Other'"
              class="row items-start"
            >
              <q-input
                label="Selected Roommates Gender Identity:"
                class="col-6"
                borderless
                readonly
              />
              <q-select
                class="col-6"
                v-model="applicationDetails.roommatesGenders"
                :options="genderList"
                multiple
                :readonly="!isEditing"
                :borderless="!isEditing"
                :hide-dropdown-icon="!isEditing"
                :rules="[checkIsEmptyGenderList]"
                lazy-rules
              >
                <template v-slot:option="{ itemProps, opt, selected, toggleOption }">
                  <q-item v-bind="itemProps">
                    <q-item-section>
                      <q-item-label v-html="opt" />
                    </q-item-section>
                    <q-item-section side>
                      <q-toggle
                        :model-value="selected"
                        @update:model-value="toggleOption(opt)"
                      />
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>

            <div class="row items-start">
              <q-input
                label="Living Learning Community (Rainbow):"
                class="col-6"
                borderless
                readonly
              />
              <q-select
                v-if="(hasRoles('HRL') && isEditing)"
                v-model="applicationDetails.livingLearningCommunityStatus"
                :options="['Requested', 'Waived', 'Approved', 'Unapproved']"
                class="col-6"
              />
              <q-input
                v-else
                :label="applicationDetails.livingLearningCommunityStatus"
                class="col-6"
                borderless
                readonly
                label-color="black"
              />
            </div>

            <div class="row items-start">
              <q-input
                label="Roommates Have Same Degree:"
                class="col-6"
                borderless
                readonly
              />
              <q-checkbox
                v-if="isEditing"
                v-model="applicationDetails.roommatesHaveSameDegree"
                label="Same Academic Degree"
                class="q-my-sm col-6"
              />
              <q-input
                v-else
                :label="$filters.yesNo(applicationDetails.roommatesHaveSameDegree)"
                class="col-6"
                borderless
                readonly
                label-color="black"
              />
            </div>
            <div class="row items-start">
              <q-input
                label="Roommates Have ESA:"
                class="col-6"
                borderless
                readonly />
              <q-checkbox
                v-if="isEditing"
                v-model="applicationDetails.roommatesHaveEmotionalSupportAnimal"
                label="Emotional Support Animal or Service Animal"
                class="q-my-sm col-6" />
              <q-input
                v-else
                :label="$filters.yesNo(applicationDetails.roommatesHaveEmotionalSupportAnimal)"
                class="col-6"
                borderless
                readonly
                label-color="black" />
            </div>
          </div>
          <!-- <div class="row items-start">
            <q-input
              label="Stay in the same unit as current unit:"
              class="col-6"
              borderless
              readonly
            />
            <q-checkbox
              v-if="isEditing"
              v-model="applicationDetails.stayInSameUnit"
              :label="$filters.yesNo(applicationDetails.stayInSameUnit)"
              class="q-my-sm col-3"
            />
            <q-input
              v-else
              :label="$filters.yesNo(applicationDetails.stayInSameUnit)"
              class="col-5"
              borderless
              readonly
              label-color="black"
            />
          </div> -->
          <div class="row items-start">
            <q-input
              label="Apartment Preference 1:"
              class="col-6"
              borderless
              readonly
            />
            <q-select
              v-model="applicationDetails.apartmentPreference1"
              :options="sessionDetails.unitTypes"
              class="col-6"
              behavior="menu"
              :readonly="!isEditing"
              :borderless="!isEditing"
              :hide-dropdown-icon="!isEditing"
              :rules="[checkSelect]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Apartment Preference 2:"
              class="col-6"
              borderless
              readonly
            />
            <q-select
              v-model="applicationDetails.apartmentPreference2"
              class="col-6"
              :options="sessionDetails.unitTypes"
              behavior="menu"
              :readonly="!isEditing"
              :borderless="!isEditing"
              :hide-dropdown-icon="!isEditing"
              :rules="[checkSelect]"
              lazy-rules
            />
          </div>

          <div>
            <div class="row items-start">
              <q-input
                label="Roommate DigiPen Email 1:"
                class="col-6"
                borderless
                readonly
              />
              <q-input
                v-model="applicationDetails.preferredRoommateDigipenEmail1"
                class="col-6"
                type="email"
                :borderless="isEditing ? false : ''"
                :readonly="isEditing ? false : ''"
                :rules="[checkIsValidEmailOrEmpty]"
                lazy-rules
              />
            </div>
            <div class="row items-start">
              <q-input
                label="Roommate DigiPen Email 2:"
                class="col-6"
                borderless
                readonly
              />
              <q-input
                v-model="applicationDetails.preferredRoommateDigipenEmail2"
                class="col-6"
                type="email"
                :borderless="isEditing ? false : ''"
                :readonly="isEditing ? false : ''"
                :rules="[checkIsValidEmailOrEmpty]"
              />
            </div>
            <div class="row items-start">
              <q-input
                label="Roommate DigiPen Email 3:"
                class="col-6"
                borderless
                readonly
              />
              <q-input
                v-model="applicationDetails.preferredRoommateDigipenEmail3"
                class="col-6"
                type="email"
                :borderless="isEditing ? false : ''"
                :readonly="isEditing ? false : ''"
                :rules="[checkIsValidEmailOrEmpty]"
                lazy-rules
              />
            </div>
            <div class="row items-start">
              <q-input
                label="Roommate DigiPen Email 4:"
                class="col-6"
                borderless
                readonly
              />
              <q-input
                v-model="applicationDetails.preferredRoommateDigipenEmail4"
                class="col-6"
                type="email"
                :borderless="isEditing ? false : ''"
                :readonly="isEditing ? false : ''"
                :rules="[checkIsValidEmailOrEmpty]"
                lazy-rules
              />
            </div>
          </div>
        </div>

        <br />

        <div>
          <div class="
                text-left
                text-h5">
            Vehicle Information
          </div>
          <q-separator />
          <q-form
            ref="vehicleForm"
            greedy
          >
            <div class="row items-start">
              <q-input
                label="Vehicle Make:"
                class="col-6"
                borderless
                readonly
              />
              <q-input
                v-model.trim="applicationDetails.vehicleMake"
                class="col-6"
                :borderless="isEditing ? false : ''"
                :readonly="isEditing ? false : ''"
                :rules="[checkVehicleInput]"
                lazy-rules
              />
            </div>
            <div class="row items-start">
              <q-input
                label="Vehicle Model:"
                class="col-6"
                borderless
                readonly
              />
              <q-input
                v-model.trim="applicationDetails.vehicleModel"
                class="col-6"
                :borderless="isEditing ? false : ''"
                :readonly="isEditing ? false : ''"
                :rules="[checkVehicleInput]"
                lazy-rules
              />
            </div>
            <div class="row items-start">
              <q-input
                label="Vehicle License Plate Number:"
                class="col-6"
                borderless
                readonly
              />
              <q-input
                v-model.trim="applicationDetails.vehicleLicense"
                class="col-6"
                :borderless="isEditing ? false : ''"
                :readonly="isEditing ? false : ''"
                :rules="[checkVehicleInput]"
                lazy-rules
              />
            </div>
            <div class="row items-start">
              <q-input
                label="Vehicle Color:"
                class="col-6"
                borderless
                readonly
              />
              <q-input
                v-model.trim="applicationDetails.vehicleColor"
                class="col-6"
                :borderless="isEditing ? false : ''"
                :readonly="isEditing ? false : ''"
                :rules="[checkVehicleInput]"
                lazy-rules
              />
            </div>
            <div class="row items-start">
              <q-input
                label="Issuing State:"
                class="col-6"
                borderless
                readonly
              />
              <q-select
                v-model="applicationDetails.vehicleState"
                class="col-6"
                :options="statesOptions"
                behavior="menu"
                :borderless="isEditing ? false : ''"
                :readonly="isEditing ? false : ''"
                :hide-dropdown-icon="isEditing ? false : ''"
                :rules="[checkVehicleInput]"
                lazy-rules
              />
            </div>
          </q-form>
          <br />
        </div>

        <div>
          <div class="text-left text-h5">
            DSS Accessibility
          </div>
          <q-separator />
          <div class="row items-start">
            <q-input
              label="DSS Accessibility Requested:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              :label="applicationDetails.dssAccessible"
              class="col-6"
              borderless
              readonly
              label-color="black"
            />
          </div>
        </div>

        <br />
        <div>
          <div class="text-left text-h5">
            My Tendencies
          </div>
          <q-separator />
          <div class="row items-start">
            <q-input
              label="I would identify with having 'good' cleanliness habits."
              class="col-10"
              borderless
              readonly
            />
            <q-checkbox
              v-if="isEditing"
              v-model="applicationDetails.cleanlinessHabits"
              :label="$filters.yesNo(applicationDetails.cleanlinessHabits)"
              class="q-my-sm col-1"
            />
            <q-input
              v-else
              :label="$filters.yesNo(applicationDetails.cleanlinessHabits)"
              borderless
              readonly
              class="col-1"
              label-color="black"
            />
          </div>
          <div class="row items-start">
            <q-input
              label="I would be open to sharing items in the apartment with my
              housemates."
              class="col-10"
              borderless
              readonly
            />
            <q-checkbox
              v-if="isEditing"
              v-model="applicationDetails.sharingHabits"
              :label="$filters.yesNo(applicationDetails.sharingHabits)"
              class="q-my-sm col-1"
            />
            <q-input
              v-else
              :label="$filters.yesNo(applicationDetails.sharingHabits)"
              borderless
              readonly
              class="col-1"
              label-color="black"
            />
          </div>
          <div class="row items-start">
            <q-input
              label="I would consider myself a social person."
              class="col-10"
              borderless
              readonly
            />
            <q-checkbox
              v-if="isEditing"
              v-model="applicationDetails.socialHabits"
              :label="$filters.yesNo(applicationDetails.socialHabits)"
              class="q-my-sm col-1"
            />
            <q-input
              v-else
              :label="$filters.yesNo(applicationDetails.socialHabits)"
              borderless
              readonly
              class="col-1"
              label-color="black"
            />
          </div>
          <!-- TODO(bryant): this is an obsolete form question now.
            maybe sunset this obsolete question next year (2025)? -->
          <div class="row items-start"
               v-if="!(isEditing && !hasRoles('R&D', 'HRL'))">
            <q-input
              label="I have Pet Dander Allergies, or am allergic to a specific type of Pet."
              class="col-10"
              borderless
              readonly
            />
            <q-checkbox
              v-if="isEditing"
              v-model="applicationDetails.hasPetAllergies"
              :label="$filters.yesNo(applicationDetails.hasPetAllergies)"
              class="q-my-sm col-1"
            />
            <q-input
              v-else
              :label="$filters.yesNo(applicationDetails.hasPetAllergies)"
              borderless
              readonly
              class="col-1"
              label-color="black"
            />
          </div>
          <div class="row items-start">
            <q-input
              label="I would consider myself a “morning person” and up early."
              class="col-10"
              borderless
              readonly
            />
            <q-checkbox
              v-if="isEditing"
              v-model="applicationDetails.isMorningPerson"
              :label="$filters.yesNo(applicationDetails.isMorningPerson)"
              class="q-my-sm col-1"
            />
            <q-input
              v-else
              :label="$filters.yesNo(applicationDetails.isMorningPerson)"
              borderless
              readonly
              class="col-1"
              label-color="black"
            />
          </div>
          <div class="row items-start">
            <q-input
              label="I would consider myself a “night owl” and am often up later."
              class="col-10"
              borderless
              readonly
            />
            <q-checkbox
              v-if="isEditing"
              v-model="applicationDetails.isNightPerson"
              :label="$filters.yesNo(applicationDetails.isNightPerson)"
              class="q-my-sm col-1"
            />
            <q-input
              v-else
              :label="$filters.yesNo(applicationDetails.isNightPerson)"
              borderless
              readonly
              class="col-1"
              label-color="black"
            />
          </div>
        </div>

        <br />
        <div v-if="hasRoles('R&D', 'HRL', 'OTHER-STAFF') && !isApply">
           <div class="text-left text-h5">
            Housing Proxies
          </div>
          <q-separator />
          <div v-for="proxy in applicationDetails.proxies" :key="proxy.userId">
            <q-separator />
            <HousingProxy
              :propProxyDetails="proxy"
              :userId="proxy.userId" />
          </div>
          <div v-if="applicationDetails.proxies.length === 0">
            <q-input
              label="No proxies have been added."
              class="col-6"
              borderless
              readonly
            />
          </div>
        </div>
        <br />
        <div v-if="hasRoles('R&D', 'HRL', 'OTHER-STAFF') && !isApply">
          <div class="text-left text-h5">
            Deposit Related
          </div>
          <q-separator />
          <div class="row items-start">
            <q-input
              label="Deposit:"
              class="col-6"
              borderless
              readonly
            />
            <q-select
              v-model="applicationDetails.deposit"
              fill-input
              borderless
              :options="['Pending', 'Received', 'Returned']"
              :readonly="hasRoles('R&D', 'HRL', 'ACC') && !isReadOnly ? false:''"
              :hide-dropdown-icon="hasRoles('R&D', 'HRL', 'ACC') && !isReadOnly ? false:''"
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Deposit Amount:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.depositAmount"
              class="col-6"
              :borderless="hasRoles('R&D', 'HRL', 'ACC') && !isReadOnly ? false : ''"
              :readonly="hasRoles('R&D', 'HRL', 'ACC') && !isReadOnly ? false: ''"
              :rules="[checkIsValidNumber]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Deposit Refund Amount:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              v-model="applicationDetails.depositRefundAmount"
              class="col-6"
              :borderless="hasRoles('R&D', 'HRL', 'ACC') && !isReadOnly ? false : ''"
              :readonly="hasRoles('R&D', 'HRL', 'ACC') && !isReadOnly ? false: ''"
              :rules="[checkIsValidNumber]"
              lazy-rules
            />
          </div>
          <div class="row items-start">
            <q-input
              label="Deposit Completed Time:"
              class="col-6"
              borderless
              readonly
            />
            <q-input
              :label="isDefaultDateTime(applicationDetails.depositCompleted)
              ? '' : applicationDetails.depositCompleted"
              class="col-6"
              borderless
              readonly
            />
          </div>
          <q-input
            class="q-ma-md"
            filled
            v-model="applicationDetails.depositRefundNotes"
            :readonly="hasRoles('R&D', 'HRL', 'ACC') && !isReadOnly ? false: ''"
            label="Deposit Refund Notes"
            type="textarea"
          />
        </div>
        <div v-if="hasRoles('R&D', 'HRL', 'OTHER-STAFF') && !isApply">
          <div class="text-left text-h5">
            Notes
          </div>
          <q-separator />
          <q-input
            class="q-ma-md"
            filled
            v-model="applicationDetails.notes"
            :readonly="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
            label="Notes"
            type="textarea"
          />
          <q-input
            class="q-ma-md"
            filled
            v-model="applicationDetails.terminateContractReason"
            :readonly="hasRoles('R&D', 'HRL') && !isReadOnly ? false: ''"
            label="Terminate Contract Reason"
            type="textarea"
          />
        </div>
      </q-form>
      <div class="row items-start">
        <div
          v-show="isEditing"
          class="text-caption q-mt-lg text-left col-12"
        >
          <b>NOTE:</b> Changes made here will not reflect in your Colleague account.
          To make changes, please visit Colleague Self-Service.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onUnmounted } from 'vue';
import { useQuasar } from 'quasar';
import useApplication from '@/hooks/application';
import useAuth from '@/hooks/auth';
import useSession from '@/hooks/session';
import useUtility from '@/hooks/utility';
import useUiUtilities from '@/utilities/uiUtilities';
import useUiValidations from '@/utilities/uiValidations';
import HousingProxy from '../Landing/HousingProxy.vue';

export default {
  props: {
    isApplying: Boolean,
    isReadOnly: Boolean,
  },
  async setup(props) {
    const $q = useQuasar();
    const {
      applicationDetails,
      getApplication,
      currentApplicationId,
      resetApplication,
      updateApplication,
      updateApplicationByAccounting,
      updateApplicationByStudent,
    } = useApplication();
    const { hasRoles } = useAuth();
    const { sessionDetails, fetchSession, resetSession } = useSession();
    const { academicYearList, getAcademicYears } = useUtility();
    const {
      countries,
      statesOptions,
      hasPassedAppilcationDeadline,
      isDefaultDateTime,
      notifyResult,
      formatApplicationManagementRequestStatus,
    } = useUiUtilities();
    const {
      checkInput,
      checkIsRoommateValid,
      checkIsValidDate,
      checkIsValidPhone,
      checkIsValidPhoneOrEmpty,
      checkIsValidEmail,
      checkIsValidEmailOrEmpty,
      checkIsValidNumber,
      checkSelect,
    } = useUiValidations();

    let isEditing = false;
    const validateForm = ref(null);
    const countriesOptions = ref(countries);
    const seaStatusOptions = ref([
      { label: 'Yes', value: true },
      { label: 'No', value: false },
      { label: 'N/A', value: null },
    ]);
    const vehicleForm = ref(null);

    onUnmounted(async () => {
      if (isEditing) {
        await resetApplication();
      }
      // resetSession();
    });

    await getAcademicYears();

    const onSubmit = async () => {
      const validationResult = await validateForm.value.validate();
      if (validationResult) {
        $q.loading.show();
        let response = '';
        if (hasRoles('R&D', 'HRL')) {
          response = await updateApplication(applicationDetails.value);
        } else if (hasRoles('ACC')) {
          response = await updateApplicationByAccounting(applicationDetails.value);
        } else {
          response = await updateApplicationByStudent(applicationDetails.value);
        }
        notifyResult(response.status, response);
        $q.loading.hide();

        return response.status;
      }

      return 400;
    };

    if (currentApplicationId.value !== null) {
      await getApplication(currentApplicationId.value);
    }

    if (sessionDetails.value.sessionName === ''
    || sessionDetails.value.sessionId !== applicationDetails.value.sessionId) {
      await resetSession();
      await fetchSession(applicationDetails.value.sessionId, true);
    }

    if (!props.isReadOnly && ((!props.isApplying && hasRoles('R&D', 'HRL'))
      || (!hasPassedAppilcationDeadline() && hasRoles('STUDENT', 'K12-STUDENT')))
    ) {
      isEditing = true;
    }

    const genderList = ref([]);

    for (let i = 0; i < sessionDetails.value.genderOptions.length; i += 1) {
      genderList.value.push(sessionDetails.value.genderOptions[i].sessionOption);
    }

    const checkIsEmptyGenderList = () => {
      if (applicationDetails.value.roommatesGenders === null) {
        return 'Please make selection(s)';
      }

      return applicationDetails.value.roommatesGenders.length !== 0 || 'Please make selection(s)';
    };

    const checkVehicleInput = () => {
      if (
        !applicationDetails.value.vehicleMake
        && !applicationDetails.value.vehicleLicense
        && !applicationDetails.value.vehicleModel
        && !applicationDetails.value.vehicleColor
        && !applicationDetails.value.vehicleState
      ) {
        return true;
      }

      if (
        applicationDetails.value.vehicleMake
        && applicationDetails.value.vehicleLicense
        && applicationDetails.value.vehicleModel
        && applicationDetails.value.vehicleColor
        && applicationDetails.value.vehicleState
      ) {
        return true;
      }

      return 'Input all vehicle fields or input none of them.';
    };

    return {
      academicYearList,
      applicationDetails,
      checkInput,
      checkIsRoommateValid,
      checkIsEmptyGenderList,
      checkIsValidDate,
      checkIsValidPhone,
      checkIsValidPhoneOrEmpty,
      checkIsValidEmail,
      checkIsValidEmailOrEmpty,
      checkIsValidNumber,
      checkSelect,
      checkVehicleInput,
      countriesOptions,
      seaStatusOptions,
      genderList,
      hasRoles,
      isApply: props.isApplying,
      isDefaultDateTime,
      isEditing,
      sessionDetails,
      statesOptions,
      onSubmit,
      validateForm,
      vehicleForm,
      formatApplicationManagementRequestStatus,
      countriesFilter(val, update) {
        update(() => {
          const needle = val.toLowerCase();
          countriesOptions.value = countries.filter((v) => v.toLowerCase().indexOf(needle) > -1);
        });
      },
    };
  },
  components: {
    HousingProxy,
  },
};
</script>
